import { H3, Paragraph } from "App/global-style";

import styled from "styled-components";

export interface DescriptionProps {
  fw: number;
  size: string;
}

export const Description = styled(Paragraph)<DescriptionProps>`
  font-size: ${({ size }) => size};
  font-weight: ${({ fw }) => fw};
  margin: 10px 0;
`;

export const DescriptionNoMargin = styled(Paragraph)`
  font-weight: 400;
  size: "14px";
`;

export const ObliqueDescription = styled(Description)`
  font-style: oblique;
`;

export const AdviceFeedback = styled.div`
  margin: 48px 0;
`;

export const StyledAdviceH3 = styled(H3)`
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const ProductCoverageContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  & > div {
    justify-content: left;
  }
`;
